/*
 * Mobile sticky Add-to-cart visibility controller.
 *
 * Swap-safe: a single set of window scroll/resize listeners is bound ONCE and
 * re-queries the current .sticky-atc-wrapper on every call, so it keeps working
 * after an AJAX product swap replaces <main>. This script is re-injected (and so
 * re-executed) by that swap; the __stickyAtcBound guard stops it from stacking a
 * fresh set of window listeners each time.
 *
 * Previously this bound once at DOMContentLoaded with captured element refs, so
 * after a swap DOMContentLoaded never fired again — the new sticky bar was never
 * wired and the old refs leaked on window listeners.
 */
(function initStickyAtc() {
  const SCROLL_THRESHOLD = 200;
  const mobileQuery =
    typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 749px)') : null;

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
  }

  function setHidden(stickyATC, hidden) {
    stickyATC.classList.toggle('is-visible', !hidden);
    // `inert` pulls the off-screen bar out of the tab order AND the accessibility
    // tree (it subsumes aria-hidden), so keyboard and screen reader users never
    // land on the hidden, duplicate Add to cart button. The CSS hides it with
    // opacity/transform/pointer-events, none of which remove keyboard
    // focusability — so inert is required here, not just aria-hidden.
    stickyATC.inert = hidden;
  }

  // Re-queries the live DOM on every call so it transparently follows the sticky
  // bar across product swaps (the swapped-in bar is first in document order).
  function updateVisibility() {
    const stickyATC = document.querySelector('.sticky-atc-wrapper');
    const addToCartBtn = document.querySelector('.product-form__buttons [type="submit"]');
    if (!stickyATC || !addToCartBtn) return;

    const isMobile = !mobileQuery || mobileQuery.matches;
    if (!isMobile) {
      setHidden(stickyATC, true);
      return;
    }

    const scrolledPastThreshold = window.scrollY >= SCROLL_THRESHOLD;
    const shouldHide = !scrolledPastThreshold || isInViewport(addToCartBtn);
    setHidden(stickyATC, shouldHide);
  }

  function throttle(func, limit) {
    let inThrottle;
    return function () {
      if (!inThrottle) {
        func.apply(this, arguments);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  // Runs on every execution, including after an AJAX swap re-injects this script:
  // reveal + set the initial state of the *current* sticky bar.
  const current = document.querySelector('.sticky-atc-wrapper');
  if (current) current.classList.remove('hidden');
  updateVisibility();

  // Bind the persistent window listeners only once. They re-query on each call,
  // so a single binding survives every product swap.
  if (!window.__stickyAtcBound) {
    window.__stickyAtcBound = true;
    window.addEventListener('scroll', throttle(updateVisibility, 100), { passive: true });
    window.addEventListener('resize', throttle(updateVisibility, 150), { passive: true });

    if (mobileQuery && typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateVisibility);
    } else if (mobileQuery && typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(updateVisibility);
    }
  }
})();
